"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const _1 = require(".");
const createInvoice_graphql_1 = tslib_1.__importDefault(require("../gql/invoices/mutations/createInvoice.graphql"));
const updateInvoice_graphql_1 = tslib_1.__importDefault(require("../gql/invoices/mutations/updateInvoice.graphql"));
const deleteInvoice_graphql_1 = tslib_1.__importDefault(require("../gql/invoices/mutations/deleteInvoice.graphql"));
const sendInvoice_graphql_1 = tslib_1.__importDefault(require("../gql/invoices/mutations/sendInvoice.graphql"));
const BaseModel_1 = tslib_1.__importDefault(require("./BaseModel"));
class Invoice extends BaseModel_1.default {
    constructor() {
        super(...arguments);
        this.createMutation = createInvoice_graphql_1.default;
        this.updateMutation = updateInvoice_graphql_1.default;
    }
    defaults() {
        return {
            uuid: '',
            invoicePrefix: '',
            invoiceNumber: 0,
            user: new _1.User(),
            date: new Date(),
            status: '',
            filters: {
                organizationUuid: '',
                groupBy: '',
                clientsFilters: {
                    name: '',
                    uuids: [],
                },
                projectsFilters: {
                    name: '',
                    uuids: [],
                },
                tasksFilters: {
                    dateRange: [],
                    description: '',
                    members: [],
                    projects: [],
                    teams: [],
                },
                teamsFilters: {
                    name: '',
                    uuids: [],
                },
            },
            data: {
                entries: [],
                summary: {},
            },
            organization: new _1.Organization(),
            client: new _1.Client(),
            createdAt: new Date(),
        };
    }
    delete() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.hydrate(yield this.mutate(deleteInvoice_graphql_1.default, {
                uuid: this.uuid,
            }));
        });
    }
    sendInvoice() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.hydrate(yield this.mutate(sendInvoice_graphql_1.default, {
                invoiceUuid: this.uuid,
            }));
        });
    }
}
exports.default = Invoice;
//# sourceMappingURL=Invoice.js.map